import { render, staticRenderFns } from "./CultivationCardSubtitle.vue?vue&type=template&id=154f7c58&scoped=true&"
import script from "./CultivationCardSubtitle.vue?vue&type=script&lang=js&"
export * from "./CultivationCardSubtitle.vue?vue&type=script&lang=js&"
import style0 from "./CultivationCardSubtitle.vue?vue&type=style&index=0&id=154f7c58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154f7c58",
  null
  
)

export default component.exports